import predicates from '../predicates'
import selectors from '../selectors'
import { EMBED_PARTNER_TRAFFIC_SOURCE } from '../constants'

const embedPartner = {
  rule: predicates.and(
    predicates.pathnameIncludesOne('embed'),
    predicates.searchParamsIncludeOne('partner')
  ),
  extractor: traffic => {
    const trafficSource = EMBED_PARTNER_TRAFFIC_SOURCE
    const trafficId = selectors.searchParamValue(traffic, 'partner')

    return {
      trafficSource,
      trafficId,
    }
  },
}

export default embedPartner



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/pipelines/embedPartner.js